import DialogButton from 'components/common/DialogButton';
import FocusableButton from 'components/common/FocusableButton';
import DrGuideDialog from 'components/dialogs/DrGuideDialog';
import T from 'utils/T';
import ex from 'utils/ex';

export default function GuideButton(props) {
  const {
    category,
    ...rest
  } = props;
  return (
    <div {...ex('GuideButtonLayout', rest)}>
      <DialogButton
        {...{ category: 'App' }}
        {...ex('GuideButton')}
        {...{
          label: (
            <svg width={60} height={64} viewBox="0 0 60 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_502_7366)">
                <path d="M17.0096 7.5C25.0481 2.85898 34.9519 2.85898 42.9904 7.5C51.0289 12.141 55.9808 20.718 55.9808 30C55.9808 39.282 51.0289 47.859 42.9904 52.5C34.9519 57.141 25.0481 57.141 17.0096 52.5C8.97114 47.859 4.01924 39.282 4.01924 30C4.01924 20.718 8.97114 12.141 17.0096 7.5Z" fill="#347AFF" />
              </g>
              <g clipPath="url(#clip0_502_7366)">
                <path d="M31 26.0027V27.5027H32.5V29.0027H31V30.5027H29.5V29.0027H28V27.5027H29.5V26.0027H31Z" fill="white" />
                <path d="M24 33.0027H36V31.5027H24V33.0027Z" fill="white" />
                <path d="M32.5 36.0026H24V34.5027H32.5V36.0026Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M26 21.0027C26 19.8981 26.8954 20.0027 28 20.0027H32C33.1046 20.0027 34 19.8981 34 21.0027H37C38.1046 21.0027 39 21.8981 39 23.0027V38.0026C39 39.1072 38.1046 40.0026 37 40.0026H23C21.8954 40.0026 21 39.1072 21 38.0026V23.0027C21 21.8981 21.8954 21.0027 23 21.0027H26ZM32 25.0027C33.1046 25.0027 34 24.1072 34 23.0027H37V38.0026H23V23.0027H26C26 24.1072 26.8954 25.0027 28 25.0027H32ZM28 22.0027V23.0027H32V22.0027H28Z" fill="white" />
              </g>
              <defs>
                <filter id="filter0_d_502_7366" x="0.0192871" y="4.01924" width="59.9614" height="59.9615" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity={0} result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dy={4} />
                  <feGaussianBlur stdDeviation={2} />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_502_7366" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_502_7366" result="shape" />
                </filter>
                <clipPath id="clip0_502_7366">
                  <rect width={24} height={24} fill="white" transform="translate(18 18)" />
                </clipPath>
              </defs>
            </svg>
          ),
        }}
      >
        <DrGuideDialog {...props} />
      </DialogButton>
    </div>
  );
}
